import * as React from 'react';
import {ReactNode, useMemo, useState} from 'react';
import {DocumentUploadContext, DocumentUploadState} from '../contexts/DocumentUploadState';
import {DocumentListType, I9DocumentType, IDocument, WorkStatus} from '@models/onboarding-review/section2-document-upload';

interface Props {
  workStatus: WorkStatus | undefined;
  children: ReactNode;
}

const DocumentUploadProvider = ({workStatus, children}: Props) => {
  const [documentListType, setDocumentListType] = useState<DocumentListType>(DocumentListType.DocListA);
  const [documentList, setDocumentList] = useState<Map<DocumentListType, IDocument[]>>(new Map());
  const [filteredDocuments, setFilteredDocuments] = useState<I9DocumentType[]>([]);

  const context = useMemo<DocumentUploadState>(
    () => ({
      documentListType,
      setDocumentListType,
      documentList,
      setDocumentList,
      workStatus,
      filteredDocuments,
      setFilteredDocuments
    }),
    [documentListType, documentList, workStatus, filteredDocuments]
  );

  return (
    <DocumentUploadContext.Provider value={context}>
      {children}
    </DocumentUploadContext.Provider>
  );
};

export default DocumentUploadProvider;



// WEBPACK FOOTER //
// ./src/providers/DocumentUploadProvider.tsx